import { render, staticRenderFns } from "./TypingMessage.vue?vue&type=template&id=1a19967e&scoped=true&"
import script from "./TypingMessage.vue?vue&type=script&lang=js&"
export * from "./TypingMessage.vue?vue&type=script&lang=js&"
import style0 from "./TypingMessage.vue?vue&type=style&index=0&id=1a19967e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a19967e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
